
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 3h20v26H5V3zm2 2v22h16V5h-7v1h-2V5H7zm7 2h2v2h-2V7zm0 3h2v2h-2v-2zm0 3h2v2.188c1.156.418 2 1.52 2 2.813 0 1.645-1.355 3-3 3s-3-1.355-3-3c0-1.292.844-2.394 2-2.813V13zm1 4c-.564 0-1 .436-1 1s.436 1 1 1 1-.436 1-1-.436-1-1-1z"}})])
          )
        }
      }
    